import axios from "axios/index";

import { mapGetters } from 'vuex';
import { debounce } from 'lodash';
import { mergeCheckout, adaptRequest } from './helpers';

const showUpdatePurchaseErrorOnce = debounce(async (error, cancelPurchace) => {
    let message = undefined;
    if(error.response.data.error === 'invalid dates') {
        message = 'Lo sentimos, esta sesión ya ha sido reservada por otra persona. Si deseas elegir otro día, deberás empezar de nuevo.'
    }else if(error.response.data.error === 'invalid status'){
        message = 'Su intento de reserva ha caducado. Debe empezar de nuevo la reserva.'
    }
    else if(error.response.data.error === 'invalid delay') {
        message = "No se puede realizar la reserva con esta antelación ya que el tiempo restante hasta la misma es inferior al mínimo establecido. Contacte con el comercio.";
        await cancelPurchace();
    }

    if(message){
        window.onbeforeunload = function () {};
        window.unload = function () {};

        alert(message);
        window.location.reload();
    }
}, 3000);

let currentController = null;


export default {
    data(){
        return {
            invalidErrors: ['invalid dates', 'Invalid ids. Booking not found', 'invalid status']
        }
    },
    computed: {
        ...mapGetters(['getToken', 'getCheckout', 'getDesign', 'getIds', 'getDateSelected', 'getExperiences']),
    },
    methods: {
        getTokenApi: function (resolve) {
            axios.post(localStorage.getItem('data-integration-aion-url') + '/api/sanctum/token', {
                email: process.env.VUE_APP_API_EMAIL,
                password: process.env.VUE_APP_API_PASSWORD
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                alert(error);
            });
        },
        getIdsApi: function (resolve) {
            axios.get(localStorage.getItem('data-integration-aion-url') + '/api/integrations', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.getToken()
                },
                params: {
                    id: localStorage.getItem('data-integration-aion-uuid')
                }
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                alert(error);
            });
        },
        getDatesApi: function(fromDate, toDate, resolve, ids) {
            const selectedIds = ids ? ids : this.getIds().split(','); 
            /* 
            selectedIds:
            Permite que se pasen los ids (Array) y si no se pasan usa los que tiene 
            el grupo de experiencias this.getIds() que es un strin separado por ","
            */
            axios.get(localStorage.getItem('data-integration-aion-url') + '/api/getMonthlyOccupancyByExperienceIdsAndDates', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer '+ this.getToken()
                },
                params: {
                    uuid: localStorage.getItem('data-integration-aion-uuid'),
                    ids: selectedIds,
                    date_start: fromDate,
                    date_end: toDate
                }
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                alert(error);
            });
        },
        getExperiencesByIdApi: function (resolve) {
            axios.get(localStorage.getItem('data-integration-aion-url') + '/api/getExperiencesByIdsAndDate', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.getToken()
                },
                params: {
                    uuid: localStorage.getItem('data-integration-aion-uuid'),
                    ids: this.getIds().split(','),
                    date: this.getDateSelected(),
                }
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getPurchaseById: function (idPurchase, resolve) {
            axios.get(localStorage.getItem('data-integration-aion-url') + '/api/getPurchaseById', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.getToken()
                },
                params: {
                    uuid: localStorage.getItem('data-integration-aion-uuid'),
                    id: idPurchase,
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getPaymentMethodsApi: function (payment, resolve) {
            const url = `${localStorage.getItem('data-integration-aion-url')}/api/getPaymentMethodsByIds`;

            axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.getToken()
                },
                params: {
                    id: localStorage.getItem('data-integration-aion-uuid'),
                    ids: [payment]
                }
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        },
        preparePaymentMethodApi: function (idPayment, resolve) {
            axios.get(localStorage.getItem('data-integration-aion-url') + '/api/payments/preparePayment',
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.getToken()
                    },
                    params: {
                        purchase_id : this.getCheckout().id,
                        customer_id: null,
                        payment_id: null,
                        payment_type: 'calendar',
                        payment_method_id : idPayment
                    }
                }
            )
            .then((response) => {
                resolve(response.data);
            }).catch((error) => {
                console.log(error)
            })
        },
        createPurchaseApi:  function (resolve) {
            const checkout = adaptRequest(this.getCheckout(), this.getExperiences());
            axios.post(localStorage.getItem('data-integration-aion-url') + '/api/postPurchase', checkout, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.getToken()
                    }
                }
            )
            .then((response) => {
                /*
                El backend no retorna todos los datos que sepasan y se pierde contexto
                por eso se hace merge de los fiends para poder tener mas datos como el tipo o el total de elementos
                esto es usado para los campos peronsalizados de tipo unidad
                */
                const updatedCheckout = mergeCheckout(checkout, response.data);
                resolve(updatedCheckout);
            })
            .catch((error) => {
                if(this.invalidErrors.some(err => err === error.response.data.error)) {
                    window.onbeforeunload = function () {};
                    window.unload = function () {};

                    alert('Lo sentimos, esta sesión ya ha sido reservada por otra persona. Si deseas elegir otro día, deberás empezar de nuevo.');
                    window.location.reload();
                }
            });
        },
        updatePurchaseApi: function (resolve) {
             // Si ya hay una solicitud en curso, cancelarla
            if (currentController) {
                currentController.abort();
            }

            // Crear un nuevo controlador para esta solicitud
            currentController = new AbortController();
            const signal = currentController.signal;

            const checkout = adaptRequest(this.getCheckout(),  this.getExperiences())
            axios.patch(localStorage.getItem('data-integration-aion-url') + '/api/patchPurchase', checkout, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.getToken()
                    },
                    signal: signal
                }
            )
            .then((response) => {
                 /*
                El backend no retorna todos los datos que sepasan y se pierde contexto
                por eso se hace merge de los fiends para poder tener mas datos como el tipo o el total de elementos
                esto es usado para los campos peronsalizados de tipo unidad
                */
                const updatedCheckout = mergeCheckout(checkout, response.data, true);
                resolve(updatedCheckout);
            })
            .catch((error) => {
                if (axios.isCancel?.(error) || error.name === 'CanceledError') {
                    console.log('Se cancela la peticion y nos quedamos solo con el resultado de la ultima peticion');
                    return;
                }

                showUpdatePurchaseErrorOnce(error, () => {
                    return new Promise((resolve) => this.cancelPurchaseApi(resolve))
                })
            });
        },
        cancelPurchaseApi: function (resolve) {
            axios.patch(localStorage.getItem('data-integration-aion-url') + '/api/deletePurchase', { id: this.getCheckout().id },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.getToken()
                    }
                }
            ).then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                resolve();
                console.log(error);
            });
        },
        cancelPurchaseById: function (resolve, idPurchase, token) {
            axios.patch(localStorage.getItem('data-integration-aion-url') + '/api/deletePurchase', { id: idPurchase },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                }
            ).then((response) => {
                resolve(response.data);
            })
                .catch((error) => {
                    console.log(error);
                });
        }
    }
}